function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40",
  viewBox: "0 0 41 40"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 25a3 3 0 01-6 0m14.8-4.5h2.2a3.775 3.775 0 014 3.5h-8.7m-3.3-5a1 1 0 01-1 1h-7l-1.854-1.855a.5.5 0 01-.146-.353V17.5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5V19zm8-2.085a.5.5 0 01-.667.471 2 2 0 010-3.772.5.5 0 01.667.471v2.83z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5 12H24a1.5 1.5 0 011.5 1.5V19a6 6 0 01-6 6h-11a5 5 0 015-5H16a5 5 0 014.972 4.469l.02.343M24.674 24a3 3 0 105.651 0"
}))));